import { useNavigate } from "react-router-dom";
import './styles.css'
import useUnicoCamera from "../../hooks/useUnicoCamera";
import { CallbackCamera, DocumentCameraTypes, ErrorPictureResponse, SelfieCameraTypes, SuccessPictureResponse } from "unico-webframe";
import useGetSession from "../../hooks/useGetSession";
import { useSendToBubble } from "../../hooks/useSendToBubble";
import { useEffect } from "react";
import useValidateSession from "../../hooks/useValidateSession";
import {ReactComponent as Loading} from '../../loading.svg';
import useTypeSession from "../../hooks/useTypeSession";

export default function Selfie() {
    const navigate = useNavigate();
    const {prepareSelfieCamera, config, loading} = useUnicoCamera();
    const {sendToBubble} = useSendToBubble(process.env.REACT_APP_SELFIE_ENDPOINT || "");
    const isValidSession = useValidateSession();
  
    useEffect(() => {
      if (isValidSession === false) {
        window.location.href = process.env.REACT_APP_REDIRECT_URL || "https://moedasocialcarbono.org.br";
        return;
      }
    }, []);

    const handleSelfie = () => {
        const callbacks: CallbackCamera = {
            on: {
                success: (obj: SuccessPictureResponse) => {
                        const session = useGetSession();
                        const type = useTypeSession();
                        const base64 = obj.base64;
                        const encrypted = obj.encrypted;

                        if (session) {
                            sendToBubble({session, base64, encrypted, type});
                            navigate(`/front-doc?session=${encodeURIComponent(session || '')}&type=${encodeURIComponent(type || '')}`, {
                                state: {
                                    session,
                                    type
                                }
                            });
                        } else {
                            console.error("Session is null");
                        }
                },
                error: (erro: ErrorPictureResponse) => {
                    console.log(erro);
                }
            }
        };
        
        prepareSelfieCamera(config, SelfieCameraTypes.NORMAL, "Selfie", false, callbacks);
    };
    

    return (
        <div className="background-container">
            <div className="container">
                <img src={process.env.PUBLIC_URL + '/icon512.png'} alt='Logo' width={300} height={42}></img>
                <p>Clique no botão abaixo para iniciar a captura de selfie</p>
                {loading ? <Loading /> : <button onClick={() => handleSelfie()}>Capturar selfie</button>}
            </div>
        </div>
    )
}